import React from "react";

import FormMailer from "./FormMailer";

export default function Footer() {
  return (
    <footer>
      <section>
        <div className="container">
          <div className="row">
            <div className="col-12 col-md-5 mb-5">
              <FormMailer />
            </div>
            <div className="col-12 col-md-6 offset-md-1">
              <div className="row">
                <div className="col-6 mb-5">
                  <img
                    className="img-fluid"
                    src="../img/logo-bc.svg"
                    alt="BalancedComp"
                  ></img>
                </div>
                <div className="col-12">
                  <p className="color-slate">
                    <strong>About BalancedComp</strong>
                  </p>
                  <p className="color-slate">
                    {" "}
                    BalancedComp is the leading expert in compensation design
                    for the financial sector, providing best-in-industry
                    consulting, web-based salary administration, and performance
                    management software with renowned processes that attract,
                    motivate, and retain a talented workforce. Currently serving
                    over 300 banks and credit unions across the U.S., we're
                    proud that 97% of our clients renew every year without a
                    contract, and we're even prouder of the quantifiable results
                    to their bottom lines and company cultures.{" "}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="py-2 py-md-3 end">
        <div className="container">
          <div className="row justify-content-center align-items-center">
            <div className="col flex-shrink-* flex-grow-0">
              <ul>
                <li>
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href="https://www.linkedin.com/company/balancedcomp-llc"
                  >
                    <i className="fab fa-linkedin"></i>
                  </a>
                </li>
                <li>
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href="https://www.facebook.com/BalancedComp/"
                  >
                    <i className="fab fa-facebook"></i>
                  </a>
                </li>
                <li>
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href="https://twitter.com/balancedcomp"
                  >
                    <i className="fab fa-x-twitter"></i>
                  </a>
                </li>
                <li>
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href="https://instagram.com/balancedcomp"
                  >
                    <i className="fab fa-instagram"></i>
                  </a>
                </li>

                <li>
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href="https://www.youtube.com/channel/UCPmOTv7HxG2scRtdCrsZw5A"
                  >
                    <i className="fab fa-youtube"></i>
                  </a>
                </li>
              </ul>
            </div>
            <div className="col flex-grow-* flex-shrink-0 d-none d-sm-block">
              <a href="https://balancedcomp.com" className="color-slate">
                <small>
                  <strong>balancedcomp.com</strong>
                </small>
              </a>
            </div>
            <div className="col flex-grow-* flex-shrink-0 text-end">
              <small className="color-slate">
                <script>© {new Date().getFullYear()} BalancedComp</script>
              </small>
            </div>
          </div>
        </div>
      </section>
    </footer>
  );
}
